function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/commands/mergecellscommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import TableUtils from '../tableutils';
import { getSelectedTableCells, isSelectionRectangular } from '../utils/selection';
import { updateNumericAttribute } from '../utils/common';
import { removeEmptyRowsColumns } from '../utils/structure';
/**
 * The merge cells command.
 *
 * The command is registered by {@link module:table/tableediting~TableEditing} as the `'mergeTableCells'` editor command.
 *
 * For example, to merge selected table cells:
 *
 *		editor.execute( 'mergeTableCells' );
 *
 * @extends module:core/command~Command
 */

var MergeCellsCommand = /*#__PURE__*/function (_Command) {
  _inherits(MergeCellsCommand, _Command);

  var _super = _createSuper(MergeCellsCommand);

  function MergeCellsCommand() {
    _classCallCheck(this, MergeCellsCommand);

    return _super.apply(this, arguments);
  }

  _createClass(MergeCellsCommand, [{
    key: "refresh",
    value:
    /**
     * @inheritDoc
     */
    function refresh() {
      var selectedTableCells = getSelectedTableCells(this.editor.model.document.selection);
      this.isEnabled = isSelectionRectangular(selectedTableCells, this.editor.plugins.get(TableUtils));
    }
    /**
     * Executes the command.
     *
     * @fires execute
     */

  }, {
    key: "execute",
    value: function execute() {
      var model = this.editor.model;
      var tableUtils = this.editor.plugins.get(TableUtils);
      model.change(function (writer) {
        var selectedTableCells = getSelectedTableCells(model.document.selection); // All cells will be merged into the first one.

        var firstTableCell = selectedTableCells.shift(); // Update target cell dimensions.

        var _getMergeDimensions = getMergeDimensions(firstTableCell, selectedTableCells, tableUtils),
            mergeWidth = _getMergeDimensions.mergeWidth,
            mergeHeight = _getMergeDimensions.mergeHeight;

        updateNumericAttribute('colspan', mergeWidth, firstTableCell, writer);
        updateNumericAttribute('rowspan', mergeHeight, firstTableCell, writer);

        var _iterator = _createForOfIteratorHelper(selectedTableCells),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var tableCell = _step.value;
            mergeTableCells(tableCell, firstTableCell, writer);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var table = firstTableCell.findAncestor('table'); // Remove rows and columns that become empty (have no anchored cells).

        removeEmptyRowsColumns(table, tableUtils);
        writer.setSelection(firstTableCell, 'in');
      });
    }
  }]);

  return MergeCellsCommand;
}(Command); // Merges two table cells. It will ensure that after merging cells with empty paragraphs the resulting table cell will only have one
// paragraph. If one of the merged table cells is empty, the merged table cell will have contents of the non-empty table cell.
// If both are empty, the merged table cell will have only one empty paragraph.
//
// @param {module:engine/model/element~Element} cellBeingMerged
// @param {module:engine/model/element~Element} targetCell
// @param {module:engine/model/writer~Writer} writer


export { MergeCellsCommand as default };

function mergeTableCells(cellBeingMerged, targetCell, writer) {
  if (!isEmpty(cellBeingMerged)) {
    if (isEmpty(targetCell)) {
      writer.remove(writer.createRangeIn(targetCell));
    }

    writer.move(writer.createRangeIn(cellBeingMerged), writer.createPositionAt(targetCell, 'end'));
  } // Remove merged table cell.


  writer.remove(cellBeingMerged);
} // Checks if the passed table cell contains an empty paragraph.
//
// @param {module:engine/model/element~Element} tableCell
// @returns {Boolean}


function isEmpty(tableCell) {
  return tableCell.childCount == 1 && tableCell.getChild(0).is('element', 'paragraph') && tableCell.getChild(0).isEmpty;
}

function getMergeDimensions(firstTableCell, selectedTableCells, tableUtils) {
  var maxWidthOffset = 0;
  var maxHeightOffset = 0;

  var _iterator2 = _createForOfIteratorHelper(selectedTableCells),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var tableCell = _step2.value;

      var _tableUtils$getCellLo2 = tableUtils.getCellLocation(tableCell),
          row = _tableUtils$getCellLo2.row,
          column = _tableUtils$getCellLo2.column;

      maxWidthOffset = getMaxOffset(tableCell, column, maxWidthOffset, 'colspan');
      maxHeightOffset = getMaxOffset(tableCell, row, maxHeightOffset, 'rowspan');
    } // Update table cell span attribute and merge set selection on a merged contents.

  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var _tableUtils$getCellLo = tableUtils.getCellLocation(firstTableCell),
      firstCellRow = _tableUtils$getCellLo.row,
      firstCellColumn = _tableUtils$getCellLo.column;

  var mergeWidth = maxWidthOffset - firstCellColumn;
  var mergeHeight = maxHeightOffset - firstCellRow;
  return {
    mergeWidth: mergeWidth,
    mergeHeight: mergeHeight
  };
}

function getMaxOffset(tableCell, start, currentMaxOffset, which) {
  var dimensionValue = parseInt(tableCell.getAttribute(which) || 1);
  return Math.max(currentMaxOffset, start + dimensionValue);
}